import { fadeInOut } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  Renderer2,
  OnChanges,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { Image } from '@dgx-pr-spa/shared/util';
import { CloseModalType } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-carousel-gallery',
  templateUrl: './carousel-gallery.component.html',
  styleUrls: ['./carousel-gallery.component.scss'],
  animations: [fadeInOut],
})
export class CarouselGalleryComponent implements OnChanges, AfterViewInit {
  /**
   * Emits a checked event back to the parent component
   */
  @Output() closed: EventEmitter<CloseModalType> = new EventEmitter();

  /**
   *
   */
  @Output() navigateModal: EventEmitter<number> = new EventEmitter();

  /**
   * Accepts an array of images
   */
  @Input() slides: Image[];

  /**
   * Get a refetence to thumbnails element
   */
  @ViewChild('thumbnails') thumbnails: ElementRef;

  /**
   * Property to determine which image is currently in view - used to seperate the on hover thumbnail and click logic
   */
  slideInView = 0;

  /**
   * Property to determine which slide is currently active - used to seperate the on hover thumbnail and click logic
   */
  activeSlide = 0;

  public CloseModalType = CloseModalType;

  constructor(public renderer: Renderer2) {}

  /**
   * On Changes triggered when new replacement is loaded
   */
  ngOnChanges() {
    this.resetUI();
    this.handleEmptyImages();
  }

  ngAfterViewInit() {
    this.navigateModal.emit(this.slideInView);
  }

  /**
   * Add empty image into array if no slides exist
   */
  handleEmptyImages() {
    if (this.slides?.length < 1) {
      this.slides = [...this.slides];
      this.slides.push({
        text: 'Image not available wording on grey background',
        url: './assets/images/img-unavailable-large-x2.png',
      });
    }
  }

  /**
   * Reset the Carousel UI
   */
  resetUI() {
    this.slideInView = 0;
    this.activeSlide = 0;
  }

  /**
   * Handle the click forward and swiperight and conditionally set the thumbnail position
   */
  onNextClick(clickedEvt = false) {
    if (this.activeSlide === this.slides.length - 1) {
      if (clickedEvt) {
        this.closed.emit(CloseModalType.Finish);
      }
      return;
    }
    this.activeSlide++;
    this.slideInView = this.activeSlide;
    this.navigateModal.emit(this.slideInView);
  }

  /**
   * Handle the click back and swipeleft and conditionally set the thumbnail position
   */
  onPreviousClick() {
    if (this.activeSlide === 0) {
      return;
    }
    this.activeSlide--;
    this.slideInView = this.activeSlide;
  }

  /**
   * Set the current slide to the thumbnail clicked via the index value
   */
  onThumbnailClick(i: number) {
    this.activeSlide = i;
    this.slideInView = this.activeSlide;
  }
}
